<template>
  <div class="div-box">
    <div class="div-list">
      <div class="list-head">
        <Button>虚拟单号</Button>
        <Button type="primary" @click="copy(1)">
          {{ $t("copy") }}
        </Button>
      </div>
      <div class="cnb-num-top">
        <span class="cnb-num" v-for="(item, index) in list" :key="index">
          {{ item }}
        </span>
      </div>
    </div>
    <div class="div-list">
      <div class="list-head">
        <Button>旧单号列表</Button>
        <Button type="primary" @click="copy(2)">
          {{ $t("copy") }}
        </Button>
      </div>
      <div class="cnb-num-top">
        <span class="cnb-num" v-for="(item, index) in oldList" :key="index">
          {{ item }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { getCargoNumber, getOldCargoNumber } from "@/api/order/package";

import copyClick from "@/utils/copyClick";

export default {
  props: {
    itemId: {
      type: Number
    }
  },
  data() {
    return {
      list: [],
      oldList: []
    };
  },
  mounted() {
    this.getList(this.itemId);
  },
  methods: {
    getList(id) {
      getCargoNumber(id).then(res => {
        this.list = res.data.payload.map(item => {
          return item.virtual_airway_number;
        });
      });
      getOldCargoNumber(id).then(res => {
        this.oldList = res.data.payload;
      });
    },
    copy(num) {
      let data = [];
      if (num == 1) {
        data = this.list.join("\r\n");
      } else {
        data = this.oldList.join("\r\n");
      }
      copyClick.copyToClipboard(data, this);
    }
  }
};
</script>
<style>
.div-box {
  width: 100%;
  position: relative;
}
.div-list {
  height: 300px;
  overflow: auto;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin: 0 auto;
  margin-bottom: 10px;
  width: 97%;
}
.list-head {
  width: calc(97% - 2px);
  border-bottom: 1px solid #e8eaec;
  display: flex;
  position: absolute;
  background: #fff;
  border-radius: 6px;
}
.list-head button {
  border: hidden;
  width: 110px;
  border-right: 1px solid #e8eaec;
  border-radius: 0;
}
.list-head button:first-child {
  border-top-left-radius: 6px;
}
.cnb-num-top {
  padding-top: 30px;
  box-sizing: border-box;
}
.cnb-num {
  border-left: 0;
  border-top: 0;
}
</style>
